/* Makes page-to-page navigation feel instant without a full SPA rewrite.
   Shopify themes are standard multi-page sites — every link click is a
   real full-page navigation, that part is normal and expected. This just
   prefetches the destination HTML the moment a shopper's cursor lingers
   on a link (or on first touch, on mobile), so by the time they actually
   click, the page is already sitting in the browser cache. */
(function () {
  if (!('fetch' in window)) return;

  var prefetched = new Set();
  var hoverTimer = null;

  function prefetch(url) {
    if (prefetched.has(url)) return;
    prefetched.add(url);
    fetch(url, { credentials: 'same-origin' }).catch(function () {});
  }

  function eligible(link) {
    if (!link || !link.href) return false;
    if (link.origin !== window.location.origin) return false;
    if (link.href === window.location.href) return false;
    if (link.hasAttribute('data-no-prefetch')) return false;
    if (/\/(cart|checkout|account\/logout)/.test(link.pathname)) return false;
    return true;
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest('a');
    if (!eligible(link)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(link.href); }, 90);
  });

  document.addEventListener('touchstart', function (e) {
    var link = e.target.closest('a');
    if (eligible(link)) prefetch(link.href);
  }, { passive: true });
})();
